import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserImport = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m14 22-3 2 13 12 13-12-3-2-8 9V6h-3v25z" }), /* @__PURE__ */ _jsx("path", { d: "M30 6v3h9v30H9V9h9V6H6v36h36V6z" })]
});
export default SvgUserImport;
